/**
 * Home is the initial default component when a user first logs in, and its job is to then send
 * the user to the right path.
 */
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import makeStyles from '@mui/styles/makeStyles'

import CircularProgress from '@mui/material/CircularProgress'

import { useAppUser, useCurrentHousehold } from './app/hooks'

const useStyles = makeStyles(
  theme => ({
    progressContainer: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center'
    }
  }),
  {
    name: 'Home'
  }
)

const Home = props => {
  const appUser = useAppUser()
  const household = useCurrentHousehold()

  // Make sure to propagate state to the next location.
  const location = useLocation()
  const { state } = location

  const classes = useStyles(props)

  if (household?.loading) {
    return (
      <section className={classes.progressContainer}>
        <CircularProgress />
      </section>
    )
  }

  return <Navigate to={appUser ? appUser.portalPath(household) : '/login'} state={state} />
}

export default Home
